import { isAioExternalSingle } from "aic";
import { AioExternalSingleWithSource, eSingleSource } from "contexts/hierarchy/interface";
import { IEditorV3, isIEditorV3 } from "editor-v3";

export interface DomainReplacements extends AioExternalSingleWithSource<IEditorV3> {
  domain: string;
  source: eSingleSource.domain;
}

/**
 * Type guard that asserts whether a value conforms to the DomainReplacements shape.
 *
 * @param obj - The object to check
 * @returns boolean
 */
export const isDomainReplacements = (obj: unknown): obj is DomainReplacements => {
  if (typeof obj !== "object" || obj === null) return false;
  // Check properties exist
  const chkObj = obj as DomainReplacements;
  // Check lower interface
  if (!isAioExternalSingle<IEditorV3>(chkObj, isIEditorV3)) return false;
  if (typeof chkObj.domain !== "string") return false;
  return true;
};
